module.exports = __webpack_public_path__ + "img/atodake.168c1f06.jpg";